import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeModification } from './bikeThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearBikeKey } from '../../sell/sellKeys';
const SLICE_NAME = 'modification';

export const modificationSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBikeModification(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeModification }).addCase(
            clearBikeKey,
            () => commonInitialState,
        );
    },
});

export const { clearBikeModification } = modificationSlice.actions;

export const modification = modificationSlice.reducer;
